import promotionApi from "api/PromotionApi";
import {
  FETCH_DELETE_DETAIL_PROMOTION_SUCCESS,
  FETCH_DETAIL_PROMOTION_SUCCESS,
  FETCH_LIST_PROMOTION_SUCCESS,
} from "redux/ActionTypes/PromotionActionTypes";
import { activeProgress, disableProgress } from "./ProgressActionCreators";

export const fetchListPromotionRequest = () => {
  return (dispatch) => {
    dispatch(activeProgress());
    return promotionApi
      .getAll()
      .then(
        (res) => {
          dispatch(fetchListPromotionSuccess(res.body));
        },
        (err) => {}
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchDetailPromotionRequest = (id) => {
  return (dispatch) => {
    dispatch(activeProgress());
    return promotionApi
      .getById(id)
      .then(
        (res) => {
          dispatch(fetchDetailPromotionSuccess(res.body));
        },
        (err) => {}
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchDeleteDetailPromotionRequest = () => {
  return (dispatch) => {
    dispatch(fetchDeleteDetailPromotionSuccess());
  };
};

export const fetchListPromotionSuccess = (data) => {
  return {
    type: FETCH_LIST_PROMOTION_SUCCESS,
    payload: data,
  };
};

export const fetchDetailPromotionSuccess = (data) => {
  return {
    type: FETCH_DETAIL_PROMOTION_SUCCESS,
    payload: data,
  };
};

export const fetchDeleteDetailPromotionSuccess = () => {
  return {
    type: FETCH_DELETE_DETAIL_PROMOTION_SUCCESS,
  };
};
